module.exports = __webpack_public_path__ + "static/media/ibd_neck1.67e5fee0.png";